import {ThunkDispatch} from "@reduxjs/toolkit";
import {connect, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import {SiteNotiIcon} from './SVGIcons'
import NotificationDisplay from './NotificationDisplay'

function mapStateToProps(state: any) {
  return {...state.siteNoti}
}

// 通知が空かどうかをチェック
function isEmptyNotification(content: string): boolean {
  if (!content || !content.trim()) return true
  
  try {
    const parsed = JSON.parse(content)
    if (parsed.root) {
      const children = parsed.root.children || []
      // 子要素がないか、空の段落のみの場合
      return children.length === 0 || 
             (children.length === 1 && 
              children[0].type === 'paragraph' && 
              (!children[0].children || children[0].children.length === 0))
    }
  } catch {
    // プレーンテキストの場合（既にtrimチェック済み）
  }
  return false
}

const SiteNoti = (props: any) => {
  const {
    noti,
  } = props
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const navigate = useNavigate()
  
  if (isEmptyNotification(noti)) return null

  return (
    <div className="flex bg-yellow-50 p-3 mb-4 rounded-md border border-yellow-500">
      <div>
        <SiteNotiIcon />
      </div>
      <NotificationDisplay 
        content={noti} 
        className="ml-3 text-yellow-700 text-sm"
      />
    </div>
  );
};

export default connect(mapStateToProps)(SiteNoti)